import React from "react";
import {RefreshOutlined} from "@mui/icons-material";
import "./error.css";

/**
 * Ловит ошибки рендера и показывает экран восстановления вместо белого экрана.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false, error: null};
    }

    static getDerivedStateFromError(error) {
        return {hasError: true, error};
    }

    componentDidCatch(error, errorInfo) {
        // eslint-disable-next-line no-console
        console.error("Admin panel render error:", error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (!this.state.hasError) {
            return this.props.children;
        }

        return (
            <div className="ui-fatal">
                <div className="ui-fatal__card">
                    <div className="ui-fatal__badge">Ошибка интерфейса</div>
                    <h1>Что-то пошло не так</h1>
                    <p>
                        Панель не смогла отрисовать этот экран. Данные не изменены.
                        Перезагрузите страницу — если ошибка повторяется, передайте
                        разработчику текст ниже.
                    </p>
                    <pre className="ui-fatal__details">
                        {String(this.state.error?.message || this.state.error || "Неизвестная ошибка")}
                    </pre>
                    <div className="ui-fatal__actions">
                        <button type="button" className="btn btn-primary" onClick={this.handleReload}>
                            <RefreshOutlined fontSize="small"/> Перезагрузить
                        </button>
                        <a className="btn btn-secondary" href="/panel">На рабочий стол</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default ErrorBoundary;
